module.exports = __webpack_public_path__ + "img/pic15.705971b2.png";